import { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const DropDown = ({ btnName, list, selectedValue, setSelectedValue }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (value) => {
        setSelectedValue(value);
        handleClose();
    };

    return (
        <div>
            <Button onClick={handleClick} color="success">
                {btnName}
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {list.map((item) => (
                    <MenuItem
                        key={item.value}
                        onClick={() => handleSelect(item.value)}
                        selected={item.value === selectedValue}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default DropDown;